/**
 * Ensure user exists.
 */
function ensureSetup({ req, res, locals }, next) {
  if (!locals.activeUser) return next();

  // If the user is still in the signup process redirect them to the current step.
  if (locals.activeUser.setup !== "finished") {
    const redirectPage = `/setup/${locals.activeUser.setup}`;
    if (redirectPage !== req.pathname) return res.redirect(redirectPage);
  }

  return next();
}

export default ensureSetup;
